import Vue from 'vue'
import IA from './IA.vue'

import router from '@/util/router'
import store from  '@/util/store'
import post from '@/util/post'

import '@/util/use'

Vue.config.productionTip = false

Vue.prototype.router = router
Vue.prototype.post = post

new Vue({
  el: '#IA',
  router,
  store,
  post,
  components: {IA},
  template: '<IA/>',
  render: h => h(IA)
}).$mount('#IA')
